<template>
<div class="chapter">
<div class="inner_page">
<p class="partt"><img alt="image" src="images/partt.jpg"/></p>
<h2 class="part-no">PART TWO</h2>
<h2 class="part-title">THE WOODS<br/>ARE LOVELY</h2>
<p class="parte"><img alt="image" src="images/parte.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?6e108875